import {
  Col,
  DatePicker,
  Form,
  InputNumber,
  Row,
  Select,
  Switch,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import React from "react";
import PayrollYearlySettingsService, { EmployeePayFrequencyOptionList } from "../../Services/PayrollYearlySettingsService";
import { useParams } from "react-router-dom";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddNIThershold = ({ itemId, onDismiss, record, isViewOnly = false }: any) => {
  const [form] = useForm();
  const { id } = useParams();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (record?.id !== undefined && record?.id !== null && record?.id !== "") {
      form.setFieldsValue({
        id: record?.id,
        payFrequency: record?.payFrequency,
        payDateFrom: record?.payDateFrom ? dayjs(record?.payDateFrom) : undefined,
        payDateTo: record?.payDateTo ? dayjs(record?.payDateTo) : undefined,
        lel: record?.lel,
        pt: record?.pt,
        st: record?.st,
        ust: record?.ust,
        aust: record?.aust,
        fust: record?.fust,
        vust: record?.vust,
        uel: record?.uel,
        auel: record?.auel,
        director: record?.director
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, itemId]);
  return (
    <SAModal
      footer={isViewOnly ? null : undefined}
      title={` ${itemId ? 'Edit' : 'Add'} NI Thershold item`}
      width={900}
      open={true}
      okText={"Save"}
      cancelText={"Cancel"}
      okButtonProps={{ loading: loading }}
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        setLoading(true);
        const yearlySettingsRecordId = id ?? "";
        const ItemId = itemId ?? "";
        form.validateFields().then(async (values: any) => {
          const val = {
            ...values,
            id: record?.id,
            payDateFrom: values?.payDateFrom ? values?.payDateFrom.format("MM-DD-YYYY") : null,
            payDateTo: values?.payDateTo ? values?.payDateTo.format("MM-DD-YYYY") : null
          };
          console.log("val", val);
          let res = await PayrollYearlySettingsService.updateNIThersholdItem(yearlySettingsRecordId, val, ItemId);
          if (res.status) {
            openNotification("success", "Details updated successfully")
            onDismiss(true);
            setLoading(false);
          } else {
            openNotification("error", res.message);
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      }}
    >
      <Form form={form} disabled={isViewOnly} requiredMark={false}>
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Pay Frequency"
              name="payFrequency"
              rules={[{ required: true, message: "Select a Pay Frequency" }]}
            >
              <Select
                placeholder="Select PayFrequency"
                className="select-height-28"
                options={EmployeePayFrequencyOptionList}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="PayDate From"
              name="payDateFrom"
              rules={[
                { required: true, message: "PayDate From is required" },
              ]}
            >
              <DatePicker
                placeholder="PayDate From"
                format='DD/MM/YYYY'
                style={{ width: "100%", height: 28 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="PayDate To"
              name="payDateTo"
              rules={[
                { required: true, message: "PayDate to is required" },
              ]}
            >
              <DatePicker
                format='DD/MM/YYYY'
                placeholder="PayDate To"
                style={{ width: "100%", height: 28 }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Lower earning limits"
              name="lel"
            >
              <InputNumber
                controls={false}
                placeholder="Lower earning limits"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Primary threshold"
              name="pt"
            >
              <InputNumber
                controls={false}
                placeholder="Primary threshold"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Secondary threshold"
              name="st"
            >
              <InputNumber
                controls={false}
                placeholder="Secondary threshold"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Upper secondary threshold"
              name="ust"
            >
              <InputNumber
                controls={false}
                placeholder="Upper secondary threshold"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Apprentice upper secondary threshold"
              name="aust"
            >
              <InputNumber
                controls={false}
                placeholder="Apprentice upper secondary threshold"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Freeport upper secondary threshold"
              name="fust"
            >
              <InputNumber
                controls={false}
                placeholder="Freeport upper secondary threshold"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Veterans upper secondary threshold"
              name="vust"
            >
              <InputNumber
                controls={false}
                placeholder="Veterans upper secondary threshold"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Upper earnings limit"
              name="uel"
            >
              <InputNumber
                controls={false}
                placeholder="Upper earnings limit"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Apprentice upper earnings limit"
              name="auel"
            >
              <InputNumber
                controls={false}
                placeholder="Apprentice upper earnings limit"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          {/* </Row> */}

          {/* <Row className="mt-1" style={{ marginBottom: -10 }} > */}
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              style={{ display: "flex", alignItems: "start", textAlign: "end" }}
              labelCol={{ xs: 12, sm: 12 }}
              wrapperCol={{ xs: 12, sm: 12 }}
              label="Director"
              name="director"
              valuePropName="checked"
            >
              <Switch disabled={isViewOnly} className="mt-1" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SAModal>
  );
};

export default AddNIThershold;
